import { get, post, put, del } from '@/lib/api-client';

// 工位状态
export enum StationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  MAINTENANCE = 'MAINTENANCE',
}

// 工位接口
export interface Station {
  id: string;
  code: string;
  nameEn: string;
  nameCn?: string;
  description?: string;
  area?: string;
  line?: string;
  type?: string;
  status: StationStatus;
  sortOrder: number;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
  _count?: {
    parts: number;
  };
}

// 分页响应
// PaginatedResponse 从 index.ts 导出，这里不重复定义
interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

// 查询参数
export interface QueryStationParams {
  search?: string;
  area?: string;
  line?: string;
  type?: string;
  status?: StationStatus;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

// 创建 DTO
export interface CreateStationDto {
  code: string;
  nameEn: string;
  nameCn?: string;
  description?: string;
  area?: string;
  line?: string;
  type?: string;
  status?: StationStatus;
  sortOrder?: number;
}

// 更新 DTO
export type UpdateStationDto = Partial<CreateStationDto>;

// 导入项
export interface ImportStationItem {
  code: string;
  nameEn: string;
  nameCn?: string;
  area?: string;
  line?: string;
  type?: string;
  description?: string;
}

// 导入结果
export interface ImportResult {
  success: number;
  failed: number;
  errors: { row: number; code: string; error: string }[];
  created: Station[];
}

// 工位 API
export const stationApi = {
  // 获取工位列表
  list: (params?: QueryStationParams): Promise<PaginatedResponse<Station>> =>
    get('/stations', { params }),

  // 获取下拉选项
  getSelectOptions: (): Promise<Pick<Station, 'id' | 'code' | 'nameEn' | 'nameCn' | 'area' | 'line'>[]> =>
    get('/stations/select'),

  // 获取单个工位
  get: (id: string): Promise<Station> =>
    get(`/stations/${id}`),

  // 创建工位
  create: (data: CreateStationDto): Promise<Station> =>
    post('/stations', data),

  // 更新工位
  update: (id: string, data: UpdateStationDto): Promise<Station> =>
    put(`/stations/${id}`, data),

  // 删除工位
  delete: (id: string): Promise<void> =>
    del(`/stations/${id}`),

  // 获取所有区域
  getAreas: (): Promise<string[]> =>
    get('/stations/areas'),

  // 获取所有产线
  getLines: (area?: string): Promise<string[]> =>
    get('/stations/lines', { params: area ? { area } : undefined }),

  // 获取所有类型
  getTypes: (): Promise<string[]> =>
    get('/stations/types'),

  // 获取导入模板
  getImportTemplate: (): Promise<ImportStationItem[]> =>
    get('/stations/import-template'),

  // 批量导入
  bulkImport: (stations: ImportStationItem[]): Promise<ImportResult> =>
    post('/stations/bulk-import', { stations }),
};

